var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconErrorModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 0C9.834 0 0 9.834 0 22C0 34.166 9.834 44 22 44C34.166 44 44 34.166 44 22C44 9.834 34.166 0 22 0ZM33 29.898L29.898 33L22 25.102L14.102 33L11 29.898L18.898 22L11 14.102L14.102 11L22 18.898L29.898 11L33 14.102L25.102 22L33 29.898Z",
    fill: "#EC5C52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErrorModal);
export default __webpack_public_path__ + "static/media/IconErrorModal.3f78fbe1262a54ee83e7a21ffc846d42.svg";
export { ForwardRef as ReactComponent };